// src/config.ts
export const apiUrl: string = process.env.REACT_APP_API_URL || '';
export const recaptchaSite: string = process.env.REACT_APP_RECAPTCHA_SITE || '';
export const recaptchaSecret: string = process.env.REACT_APP_RECAPTCHA_SECRET || '';
export const auth0redirect: string = process.env.REACT_APP_AUTH0_CALLBACK_URL || '';

// Feature flags
export const isTimebestillingEnabled: boolean = process.env.REACT_APP_ENABLE_TIMEBESTILLING === 'true' || process.env.NODE_ENV === 'development';